import styled from 'styled-components';
import { em, rem } from 'styles';
import { PALETTE, RECORD_BLUE, RECORD_BAR_HEIGHT } from '../../fields.constants';

export const Bar = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: ${({ theme }) => theme.zIndexes[3]};
  display: flex;
  align-items: center;
  gap: ${em(12)};
  height: ${em(RECORD_BAR_HEIGHT)};
  padding: 0 ${em(16)};
  font-size: ${rem(13.5)};
  color: ${PALETTE.recordText};
  white-space: nowrap;
  background: ${PALETTE.recordBg};
  border-bottom: ${em(1)} solid ${PALETTE.recordBorder};

  b {
    min-width: 0;
    overflow: hidden;
    font-weight: 700;
    text-overflow: ellipsis;
  }
`;

export const Text = styled.span`
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const BackButton = styled.button`
  flex: none;
  padding: 0;
  font-size: ${rem(13.5)};
  font-weight: 500;
  color: ${RECORD_BLUE};
  text-decoration: underline;
  background: none;
  border: none;
  cursor: pointer;
`;
